import axios from 'axios';
import * as Cookie from 'js-cookie';
import { Environment } from '../../environment/environment';
import { Notification } from '../../index';
// tslint:disable

export class Authorize {

    public static setNewPassword(password: string, token: string): Promise<boolean> {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post(Environment.get('api.setNewPassword'), {
                    password: password,
                    token: token
                }, {withCredentials: true});

                resolve(true);
            } catch (e) {
                reject(e);
            }
        });
    }


    public static forgotPassword(email: string): Promise<boolean> {
        return new Promise(async (resolve, reject) => {
            try {
                 const response: any = await axios.post(Environment.get('api.resetPassword'), {
                    email: email,
                 }, {withCredentials: true, headers: {'request-source': 'admin'}});

                resolve(response);
            } catch (e) {
                reject(e);
            }
        });
    }

    public static login(email: string, password: string): Promise<boolean> {
        return new Promise(async (resolve, reject) => {
            try {
                const response: any = await axios.post(Environment.get('api.login'), {
                    email: email,
                    password: password
                }, {withCredentials: true});

                if (response.data.site) {
                    Cookie.set('site', response.data.site);
                }
                if (response.data.user) {
                    Cookie.set('user', response.data.user);
                }

                if (response.data.sites) {
                    Cookie.set('sites', response.data.sites);
                }

                if (response.data.accessToken) {
                    Cookie.set('accessToken', response.data.accessToken);
                    resolve(true);
                } else {
                    reject();
                }
            } catch (e) {
                reject(e);
            }
        });
    }

    public static async authorize() {
        try {
            await axios.get(Environment.get('api.authorize'), {
                withCredentials: true,
            });

        } catch (err) {
            Notification.authFailed();
            // tslint:disable-next-line
            setTimeout(() =>{
                window.location.replace('/login');
            }, 1000)

        }
    }

    public static logout() {
        Cookie.remove('accessToken');
        Cookie.remove('site');
        Cookie.remove('sites');
        window.location.href = '/login';
    }
}



// WEBPACK FOOTER //
// ./src/components/libs/authorize.ts